import { withPrefix } from 'gatsby'

export default {
  metadata: {
    title: 'We believe in better insurance technology. - artificial',
    desc: 'We’re using the latest cloud-based tools and techniques in Machine Learning to provide insurers and their customers with a better experience.',
  },
  ArHeroHeader: {
    image: {
      url: withPrefix('img/ArHeroHeaderCompanyAbout.png'),
    },
    title: ['We believe in a ', { tag: 'strong', options: { innerText: 'better' } }, ' insurance experience'],
    titleAsHtml: true,
  },
  ArTextWithImageHalvedOnTablet: {
    items: [
      {
        title: 'Our mission',
        description: [
          'We’ve seen how hard it can be for insurers and their customers to navigate the traditional insurance life cycle with its endless paperwork and costly manual processes.',
          { tag: 'br' },
          { tag: 'br' },
          'At Artificial, we’re using the latest cloud-based tools and techniques in Machine Learning to digitise the quote, bind and issue process, at all times focusing on providing insurers and their customers with a better experience.',
          { tag: 'br' },
          { tag: 'br' },
          'The ',
          { tag: 'strong', options: { innerText: 'artificialOS' } },
          ' modular platform allows you to capture data only once - making it easy to simplify the pricing, distribution and selection of risk.',
          { tag: 'br' },
          { tag: 'br' },
          'Our system allows end-to-end data flows that harness Machine Learning, providing customers with an excellent experience whilst realising efficiency gains.',
        ],
        image: {
          url: withPrefix('img/ArTextWithImage14.png'),
        },
        scTitleBottomMargins: ['20px', '30px', '30px'],
        scComponentMargins: {
          top: ['40px', '45px', '127px'],
          bottom: ['40px', '80px', '160px'],
        },
        scImageMargins: {
          right: ['0', '0', '0'],
          bottom: ['0', '0', '0'],
          left: ['0', '-48.12%', '0'],
        },
        scImageWidth: [null, 600, 600],
        scGap: [0, 80, 140],
      },
    ],
  },
  ArCompanyTeam: {
    title: 'Our senior team',
    description: 'Find out more about the people behind Artificial.',
    team: [
      {
        image: {
          alt: 'Damian Arnold',
          url: withPrefix('img/ArCompanyTeam3.png'),
        },
        title: 'Damian Arnold',
        subtitle: 'CEO',
        description: 'Previously the International COO of Direct Line, Damian has vast experience in running at scale as well as fund raising.',
      },
      {
        image: {
          alt: 'David King',
          url: withPrefix('img/ArCompanyTeam1.png'),
        },
        title: 'David King',
        subtitle: 'Founder & CCO',
        description: 'David has worked across insurance, media and tech companies. He understands what decision makers are looking for and what needs to be delivered as part of a market-leading solution.',
      },
      {
        image: {
          alt: 'Johnny Bridges',
          url: withPrefix('img/ArCompanyTeam2.png'),
        },
        title: 'Johnny Bridges',
        subtitle: 'Founder & CPO',
        description: 'Johnny has extensive experience working within the insurance industry, meaning he is uniquely placed to understand both what is needed in the market and what is possible with the latest tech.',
      },
      {
        image: {
          alt: 'Alexis Renaudin',
          url: withPrefix('img/ArCompanyTeam6.png'),
        },
        title: 'Alexis Renaudin',
        subtitle: 'Head of Data Science',
        description: 'Alexis shares our vision and hunger for what can be achieved in Insurtech. He leads our Machine Learning team.',
      },
      {
        image: {
          alt: 'Artur Kisiolek',
          url: withPrefix('img/ArCompanyTeam4.png'),
        },
        title: 'Artur Kisiolek',
        subtitle: 'CTO',
        description: 'Artur has 15 years’ experience in building the very best technology used by millions across the world.',
      },
      {
        image: {
          alt: 'Dipika Carter',
          url: withPrefix('img/ArCompanyTeam5.png'),
        },
        title: 'Dipika Carter',
        subtitle: 'Head of Delivery',
        description: 'Dipika brings 20 years of insurance industry experience to the team and leads our team of business analysts and PMs.',
      },
      {
        image: {
          alt: 'David Hawkins',
          url: withPrefix('img/ArCompanyTeam7.png'),
        },
        title: 'David Hawkins',
        subtitle: 'Head of Design',
        description: 'David brings eight years of UX Design experience to Artificial and leads our design team.',
      },
    ],
  },
  ArCompanyStory: {
    title: 'Our story',
    items: [
      {
        title: '2013',
        description: 'In 2013 we began building highly polished, data intensive, digital applications for some of the world’s biggest brands.',
      },
      {
        title: '2015',
        description: 'In 2015, we opened an office in Warsaw alongside our HQ in London and won our first insurance client.',
      },
      {
        title: '2019',
        description: `As of 2019 we’ve finished our seed round and are working with some of the world’s largest brokers and underwriters.
        We’re just getting started!`,
      },
    ],
  },
  ArPartnersWithImage: {
    title: 'Partnerships',
    partners: [
      {
        image: { url: withPrefix('img/ArPartnersWithImage1.png') },
        logo: { url: withPrefix('img/ArPartners3.svg') },
        description: 'We are partnered with Capita Plc as part of the Capita Scaling Partners programme. This collaboration allows us to rapidly offer our products directly to all leading insurers that use Capita.',
      },
      {
        image: { url: withPrefix('img/ArPartnersWithImage2.png') },
        logo: { url: withPrefix('img/ArPartnersPINGAN.svg') },
        description: 'Our latest partnership is with leading insurer Ping An as part of the Ping An accelerator programme.',
      },
    ],
  },
}
